// Routes
export const HOME = '';
export const WORKFLOWS = '/workflows/*';
export const SNAGS = '/snags/*';
